import axios from 'axios';
import { saveAs } from 'file-saver';
import Jszip from 'jszip';
import { forEach, map, remove } from 'lodash';
import moment from 'moment';
import Swal from 'sweetalert2';
import {
  DOCFIS_SET_BUSCAR_DOCUMENTO_FAIL,
  DOCFIS_SET_BUSCAR_DOCUMENTO_SUCCESS,
  DOCFIS_SET_DELETE_FAIL,
  DOCFIS_SET_DOCUMENTO_FISCAL_FAIL,
  DOCFIS_SET_DOCUMENTOS_FISCAIS_FAIL,
  DOCFIS_SET_DOCUMENTOS_FISCAIS_SUCCESS,
  DOCFIS_SET_DOWNLOAD_DOCUMENTOS_FISCAIS_FAIL,
  DOCFIS_SET_DOWNLOAD_DOCUMENTOS_FISCAIS_SUCCESS,
  DOCFIS_SET_EXTRACT_FAIL,
  DOCFIS_SET_EXTRACT_SUCCESS,
  DOCFIS_SET_NOTA_FISCAL_SUCCESS,
} from './types';
import { bytesToMegabytes } from '../utils';
import { FILE_EXTENSIONS } from '../consts';

import box from '../api/box';
import { history } from '../history';
import {
  createSuccessNotification,
  sendErroRequest,
  sendWarningModalXMLImport,
  sendSuccessModalXMLImport,
  createInfoNotification,
  closeNotification,
  createErrorNotification,
} from '../utils/Notification';
import { buildFilter, FILTER_CONDITIONS } from '../utils/query-filter';

const urlBaseEnviar = '/v1/enviar-documentos';
const urlBaseDocumentos = '/v1/documentos-fiscais';

export const setDocumentosFiscaisSuccess = payload => ({
  type: DOCFIS_SET_DOCUMENTOS_FISCAIS_SUCCESS,
  payload,
});

export const setDocumentosFiscaisFail = () => ({
  type: DOCFIS_SET_DOCUMENTOS_FISCAIS_FAIL,
});

export const setDocumentoFiscalSuccess = payload => ({
  type: DOCFIS_SET_NOTA_FISCAL_SUCCESS,
  payload,
});

export const setDocumentoFiscalFail = () => ({
  type: DOCFIS_SET_DOCUMENTO_FISCAL_FAIL,
});

export const setDownloadDocumentoFiscalSuccess = () => ({
  type: DOCFIS_SET_DOWNLOAD_DOCUMENTOS_FISCAIS_SUCCESS,
});

export const setDownloadDocumentoFiscalFail = () => ({
  type: DOCFIS_SET_DOWNLOAD_DOCUMENTOS_FISCAIS_FAIL,
});

export const setDocumentosSelecionadosSuccess = payload => ({
  type: DOCFIS_SET_EXTRACT_SUCCESS,
  payload,
});

export const setDocumentosSelecionadosFail = () => ({
  type: DOCFIS_SET_EXTRACT_FAIL,
});

export const setDeleteFail = () => ({
  type: DOCFIS_SET_DELETE_FAIL,
});

const setBuscarDocumentosSuccess = () => ({
  type: DOCFIS_SET_BUSCAR_DOCUMENTO_SUCCESS,
});

const setBuscarDocumentosFail = () => ({
  type: DOCFIS_SET_BUSCAR_DOCUMENTO_FAIL,
});

export const getDocumentosFiscais = filtroForm => async dispatch => {
  try {
    const {
      initialDate,
      finalDate,
      storageFinalDate,
      storageInicialDate,
      stateRegistry,
      documentType,
      documentOrigem,
      codigoProduto,
      nome,
      ncm,
    } = filtroForm;
    const documentKey = filtroForm.documentKey && filtroForm.documentKey.trim();
    const documentNumber = filtroForm.documentNumber && filtroForm.documentNumber.trim();

    const filtroArray = [];

    const searchParams = new URLSearchParams();

    searchParams.set('searching', true);

    if (initialDate) {
      const dataInicial = moment(initialDate).format('YYYYMMDD');

      filtroArray.push(
        buildFilter(
          'dataEmissaoDocumento',
          dataInicial,
          FILTER_CONDITIONS.GREATER_THAN_OR_EQUAL_TO,
        ),
      );

      searchParams.set('initialDate', dataInicial);
    }

    if (finalDate) {
      const dataFinal = moment(finalDate).format('YYYYMMDD');

      filtroArray.push(
        buildFilter('dataEmissaoDocumento', dataFinal, FILTER_CONDITIONS.LESSER_THAN_OR_EQUAL_TO),
      );

      searchParams.set('finalDate', dataFinal);
    }

    if (storageInicialDate) {
      const dataArmazenamentoInicial = moment(storageInicialDate, 'YYYYMMDDHHmm')
        .startOf('day')
        .format('YYYYMMDDHHmm');

      filtroArray.push(
        buildFilter(
          'dataArmazenamento',
          dataArmazenamentoInicial,
          FILTER_CONDITIONS.GREATER_THAN_OR_EQUAL_TO,
        ),
      );

      searchParams.set('storageDate', dataArmazenamentoInicial);
    }

    if (storageFinalDate) {
      const dataArmazenamentoFinal = moment(storageFinalDate, 'YYYYMMDDHHmm')
        .endOf('day')
        .format('YYYYMMDDHHmm');

      filtroArray.push(
        buildFilter(
          'dataArmazenamento',
          dataArmazenamentoFinal,
          FILTER_CONDITIONS.LESSER_THAN_OR_EQUAL_TO,
        ),
      );

      searchParams.set('storageDate', dataArmazenamentoFinal);
    }

    if (stateRegistry) {
      filtroArray.push(buildFilter('inscricaoEstadual', stateRegistry));
      searchParams.set('stateRegistry', stateRegistry);
    }

    if (documentKey) {
      filtroArray.push(buildFilter('chaveDocumentoFiscal', documentKey));
      searchParams.set('documentKey', documentKey);
    }

    if (documentType) {
      filtroArray.push(buildFilter('tipoDocumentoFiscal', documentType));
      searchParams.set('documentType', documentType);
    }

    if (documentOrigem) {
      filtroArray.push(buildFilter('dadosOrigem.origem', documentOrigem));
      searchParams.set('documentOrigem', documentOrigem);
    }

    if (documentNumber) {
      filtroArray.push(buildFilter('numeroDocumentoFiscal', documentNumber));
      searchParams.set('documentNumber', documentNumber);
    }
    // filtro de produtos

    if (codigoProduto) {
      filtroArray.push(buildFilter('codigoProduto', codigoProduto));
      searchParams.set('codigoProduto', codigoProduto);
    }

    if (nome) {
      filtroArray.push(buildFilter('nome', nome));
      searchParams.set('nome', nome);
    }

    if (ncm) {
      filtroArray.push(buildFilter('ncm', ncm));
      searchParams.set('ncm', ncm);
    }

    const params = {
      ...(filtroArray.length > 0 && { filtro: JSON.stringify(filtroArray) }),
    };

    if (history.location.pathname !== '/documentos-fiscais') {
      history.push(`/documentos-fiscais?${searchParams.toString()}`);
    } else {
      history.push(`?${searchParams.toString()}`);
    }

    const { data } = await box.get(urlBaseDocumentos, { params });

    closeNotification();
    if (data.length === 0) {
      createInfoNotification('Nenhum documento localizado para o filtro informado.', {
        timer: 3000,
      });
    }

    dispatch(setDocumentosFiscaisSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os Documentos Fiscais');

    dispatch(setDocumentosFiscaisFail());
  }
};

export const getDocumentoFiscal = (id, cb) => async dispatch => {
  try {
    const { data } = await box.get(`${urlBaseDocumentos}/${id}`);

    dispatch(setDocumentoFiscalSuccess(data));

    if (cb && typeof cb === 'function') cb();
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar o Documento Fiscal');

    dispatch(setDocumentoFiscalFail());
  }
};

const enviarArquivo = async (arquivos, pessoa) => {
  try {
    const formData = new FormData();

    // Upload Manual
    formData.append('origem', '2');
    formData.append('originador', pessoa);
    forEach(arquivos, data => formData.append('arquivos', data.arquivo, data.nomeArquivo));

    const { data } = await box.post(`${urlBaseEnviar}/multiple`, formData);

    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const getFiles = (files, clearUploaderFunction) => async (dispatch, getState) => {
  if (files.length === 0) return;

  // Se for atualizar o tamanho máximo, realizar essa atualização também no back-end para a descompactação de arquivos RAR em
  // DocumentoFiscalController -> DescompactarArquivoAsync
  const MAX_FILES_SIZE_IN_BYTES = 209715200;
  const STATUS_NOT_UPLOADED = 'Não enviado';

  const getDocumentObject = (nomeArquivo, arquivo, situacao) => ({
    nomeArquivo,
    arquivo,
    situacao,
  });

  const zipFileTypes = ['application/x-zip-compressed', 'application/zip'];

  try {
    const filesTotalSizeInBytes = files.reduce((sum, file) => sum + file.size, 0);
    if (filesTotalSizeInBytes >= MAX_FILES_SIZE_IN_BYTES) {
      const maxFilesSizePrettified = Math.floor(bytesToMegabytes(MAX_FILES_SIZE_IN_BYTES, true));
      createErrorNotification(
        `O tamanho total dos arquivos não pode ultrapassar ${maxFilesSizePrettified} MB`,
      );
      return;
    }

    const {
      documentoFiscal: { documentosSelecionados },
    } = getState();

    const documentsUpload = [...documentosSelecionados];

    const promises = files.map(async file => {
      const isZipFile = zipFileTypes.includes(file.type);
      const isRarFile = getFileExtension(file.name) === FILE_EXTENSIONS.RAR;

      if (isZipFile) {
        const extractedFiles = await extractZipFile(file);

        const filteredFiles = filterXmlFiles(extractedFiles);

        const promisesXmlExtraction = Object.keys(filteredFiles).map(async fileName => {
          const xmlString = await filteredFiles[fileName].async('string');
          const xml = xmlStringToBlob(xmlString);

          documentsUpload.push(getDocumentObject(fileName, xml, STATUS_NOT_UPLOADED));
        });

        await Promise.all(promisesXmlExtraction);
      } else if (isRarFile) {
        const formData = new FormData();
        formData.append('arquivoCompactado', file);

        const { data } = await box.post(`${urlBaseDocumentos}/descompactar-arquivo`, formData);

        data.forEach(fileResponse => {
          const { nome: fileName, conteudo: xmlString } = fileResponse;

          const xml = xmlStringToBlob(xmlString);

          documentsUpload.push(getDocumentObject(fileName, xml, STATUS_NOT_UPLOADED));
        });
      } else {
        documentsUpload.push(getDocumentObject(file.name, file, STATUS_NOT_UPLOADED));
      }
    });

    await Promise.all(promises);

    dispatch(setDocumentosSelecionadosSuccess(documentsUpload));
  } catch (error) {
    sendErroRequest(error, 'Ocorreu um erro durante a importação do arquivo!');

    dispatch(setDocumentosSelecionadosFail());
  } finally {
    // A função atual (getFiles) é disparada toda vez que a função 'clearUploaderFunction' é executada, portanto foi preciso incluir o check se
    // há arquivos na execução atual para que não ocorra um loop infinito e consequentemente o crash da aplicação.
    if (typeof clearUploaderFunction === 'function' && files.length > 0) clearUploaderFunction();
  }
};

const extractZipFile = async file => {
  const jszip = new Jszip();

  const { files } = await jszip.loadAsync(file);

  return files;
};

const getFileExtension = fileName => fileName.split('.').pop();

const filterXmlFiles = files => {
  const filteredFiles = {};
  Object.keys(files).forEach(fileName => {
    if (!getFileExtension(fileName) === FILE_EXTENSIONS.XML) return;
    filteredFiles[fileName] = files[fileName];
  });

  return filteredFiles;
};

const xmlStringToBlob = xmlString => new Blob([xmlString], { type: 'text/xml' });

export const uploadFiles = (files, setPercentual, setEstadoProgresso, cb) => async (
  dispatch,
  getState,
) => {
  const MAX_FILES_PER_REQUEST = 300;

  try {
    const {
      usuario: { pessoaLogada },
    } = getState();

    const arquivosAnteriores = [];
    const documentosFiscais = [];

    setEstadoProgresso(1);
    for (let i = 0; i < files.length; i += 1) {
      const item = files[i];

      if (item.arquivo) {
        documentosFiscais.push(item);
      } else {
        arquivosAnteriores.push(item);
      }

      setPercentual(Math.round((i / (files.length - 1)) * 100));
    }

    let documentosInseridos = [];
    let documentosNaoInseridos = [];

    setEstadoProgresso(2);
    setPercentual(0);
    const progresso = { concluidos: 0, percentual: 0 };
    let arquivos = [];
    const responseEnviarArquivo = [];
    for (let index = 0; index < documentosFiscais.length; index += 1) {
      const documentoFiscal = documentosFiscais[index];

      arquivos.push({ nomeArquivo: documentoFiscal.nomeArquivo, arquivo: documentoFiscal.arquivo });

      if (arquivos.length === MAX_FILES_PER_REQUEST || index === documentosFiscais.length - 1) {
        const arquivosEnviar = [...arquivos];
        responseEnviarArquivo.push(
          new Promise(async resolve => {
            const response = await enviarArquivo(arquivosEnviar, pessoaLogada.nome);

            progresso.concluidos += MAX_FILES_PER_REQUEST;
            const novoPercentual = Math.round(
              (progresso.concluidos / (documentosFiscais.length - 1)) * 100,
            );

            if (novoPercentual > progresso.percentual) {
              progresso.percentual = novoPercentual > 100 ? 100 : novoPercentual;
              setPercentual(novoPercentual);
            }

            resolve(response);
          }),
        );
        arquivos = [];
      }
    }

    const resposta = await Promise.all(responseEnviarArquivo);

    resposta.forEach(item => {
      documentosInseridos = [...documentosInseridos, ...item.documentosInseridos];
      documentosNaoInseridos = [...documentosNaoInseridos, ...item.documentosNaoInseridos];
    });

    setEstadoProgresso(3);

    dispatch({ type: 'UPLOAD_SUCCESS' });

    const response = {
      total: documentosInseridos.length + documentosNaoInseridos.length,
      importados: documentosInseridos.length,
      erros: documentosNaoInseridos.length,
    };

    const inseridos = documentosInseridos.map(documento => {
      return {
        nomeArquivo: documento.nomeArquivo,
        chaveDocumentoFiscal: documento.chaveDocumentoFiscal,
        situacao: 'Importado',
        response: { sucesso: true, mensagem: 'Inserido com sucesso' },
      };
    });

    const naoInseridos = documentosNaoInseridos.map(documento => {
      return {
        nomeArquivo: documento.nomeArquivo,
        situacao: 'Não Importado',
        response: { sucesso: false, mensagem: documento.mensagem, erros: documento.erros },
      };
    });

    const resultado = [...arquivosAnteriores, ...inseridos, ...naoInseridos];
    setPercentual(100);

    if (cb && typeof cb === 'function') cb(resultado, response);
  } catch (error) {
    dispatch({ type: 'UPLOAD_FAIL' });

    sendErroRequest(error, 'Não foi possível fazer o upload dos arquivos');
  }
};

export const downloadPDF = (id, chave, cb) => async dispatch => {
  try {
    const { data } = await box.get(`${urlBaseDocumentos}/download/${id}`, {
      responseType: 'blob',
    });

    saveAs(data, `${chave}.pdf`);

    dispatch(setDownloadDocumentoFiscalSuccess());

    if (cb && typeof cb === 'function') cb();
  } catch (error) {
    sendErroRequest(error, 'Não foi possível baixar o PDF');

    dispatch(setDownloadDocumentoFiscalFail());
  }
};

export const downloadDocumentosFiscaisPDF = (selectedRows, cb) => async (dispatch, getState) => {
  try {
    const {
      empresa: {
        dadosEmpresa: { configuracaoEmpresa },
      },
    } = getState();

    const zipFile = new Jszip();

    const pdfs = {};
    const promises = [];

    for (const row of selectedRows) {
      promises.push(
        new Promise(async resolve => {
          const { data } = await box.get(`${urlBaseDocumentos}/download/${row.id}`, {
            responseType: 'blob',
          });

          resolve({
            data,
            row,
          });
        }),
      );
    }

    const listaDownload = await Promise.all(promises);

    listaDownload.forEach(({ data, row }) => {
      pdfs[row.chaveDocumentoFiscal] = data;
    });

    Object.keys(pdfs).forEach(key => {
      const chaveDocumentoFiscal = key;
      const file = pdfs[key];

      if (configuracaoEmpresa && configuracaoEmpresa.estruturaDownload > 0) {
        const documentoFiscal = selectedRows.find(
          d => d.chaveDocumentoFiscal === chaveDocumentoFiscal,
        );

        if (documentoFiscal) {
          const pastaMesAno = moment(documentoFiscal.dataEmissaoDocumentoFormatada).format(
            'YYYY/MM',
          );

          switch (configuracaoEmpresa.estruturaDownload) {
            case 1:
              zipFile.folder(pastaMesAno).file(`${chaveDocumentoFiscal}.pdf`, file);
              break;
            case 2:
              zipFile
                .folder(pastaMesAno)
                .folder(documentoFiscal.dadosEmitenteDestinatario.inscricao)
                .file(`${chaveDocumentoFiscal}.pdf`, file);
              break;
            case 3:
              zipFile
                .folder(pastaMesAno)
                .folder(documentoFiscal.dadosEmitenteDestinatario.razaoSocial)
                .file(`${chaveDocumentoFiscal}.pdf`, file);
              break;
            default:
              zipFile.file(`${chaveDocumentoFiscal}.pdf`, file);
              break;
          }
        }
      } else {
        zipFile.file(`${chaveDocumentoFiscal}.pdf`, file);
      }
    });

    const blob = await zipFile.generateAsync({ type: 'blob' });

    saveAs(blob, 'DocumentosFiscais.zip');

    dispatch(setDownloadDocumentoFiscalSuccess());

    if (cb && typeof cb === 'function') cb();
  } catch (error) {
    sendErroRequest(error, 'Não foi possível baixar os Documentos Fiscais');

    dispatch(setDownloadDocumentoFiscalFail());
  }
};

const baixarXmlComRenovacaoSas = async download => {
  try {
    const response = await axios.get(download.url, { responseType: 'blob' });
    return { response, download };
  } catch (error) {
    const status = error.response && error.response.status;
    if (status !== 403) throw error;

    const { data: downloadRenovado } = await box.post(
      `${urlBaseDocumentos}/${download.id}/url-download-xml`,
    );
    const response = await axios.get(downloadRenovado.url, { responseType: 'blob' });

    return { response, download: downloadRenovado };
  }
};

export const downloadXML = (id, chaveDocumentoFiscal) => async dispatch => {
  try {
    const { data: download } = await box.post(`${urlBaseDocumentos}/${id}/url-download-xml`);
    const resultado = await baixarXmlComRenovacaoSas(download);

    saveAs(
      resultado.response.data,
      resultado.download.nomeArquivo || `${chaveDocumentoFiscal}.xml`,
    );

    dispatch(setDownloadDocumentoFiscalSuccess());
  } catch (error) {
    sendErroRequest(error, 'Não foi possível baixar o XML');

    dispatch(setDownloadDocumentoFiscalFail());
  }
};

export const downloadDocumentosFiscais = (selectedRows, fileName, cb) => async (
  dispatch,
  getState,
) => {
  try {
    const {
      empresa: {
        dadosEmpresa: { configuracaoEmpresa },
      },
    } = getState();

    const zipFile = new Jszip();

    const { data: downloads } = await box.post(
      `${urlBaseDocumentos}/urls-download-xml`,
      selectedRows.map(selectedRow => selectedRow.id),
    );

    const promises = downloads.map(download => baixarXmlComRenovacaoSas(download));

    const documentsReport = {
      success: 0,
      failed: [],
    };
    const promisesQueue = await Promise.allSettled(promises);
    const filesResponse = [];
    promisesQueue.forEach((item, index) => {
      const download = downloads[index];
      if (item.status === 'rejected') {
        const fails = selectedRows.find(documento => documento.id === download.id);
        fails &&
          documentsReport.failed.push({
            error: {
              message: item.reason.message,
              data: item.reason.response,
            },
            numeroDocumentoFiscal: fails.numeroDocumentoFiscal,
          });
      } else {
        documentsReport.success += 1;
        filesResponse.push({
          data: item.value.response.data,
          download: item.value.download,
        });
      }
    });

    if (documentsReport.success > 0) {
      filesResponse.forEach(({ data, download }) => {
        const { chaveDocumentoFiscal } = download;

        if (configuracaoEmpresa && configuracaoEmpresa.estruturaDownload > 0) {
          const documentoFiscal = selectedRows.find(
            d => d.chaveDocumentoFiscal === chaveDocumentoFiscal,
          );

          if (documentoFiscal) {
            const pastaMesAno = moment(documentoFiscal.dataEmissaoDocumentoFormatada).format(
              'YYYY/MM',
            );

            switch (configuracaoEmpresa.estruturaDownload) {
              case 1:
                zipFile.folder(pastaMesAno).file(`${chaveDocumentoFiscal}.xml`, data);
                break;
              case 2:
                zipFile
                  .folder(pastaMesAno)
                  .folder(documentoFiscal.dadosEmitenteDestinatario.inscricao)
                  .file(`${chaveDocumentoFiscal}.xml`, data);
                break;
              case 3:
                zipFile
                  .folder(pastaMesAno)
                  .folder(documentoFiscal.dadosEmitenteDestinatario.razaoSocial)
                  .file(`${chaveDocumentoFiscal}.xml`, data);
                break;
              default:
                zipFile.file(`${chaveDocumentoFiscal}.xml`, data);
                break;
            }
          }
        } else {
          zipFile.file(`${chaveDocumentoFiscal}.xml`, data);
        }
      });

      const blob = await zipFile.generateAsync({ type: 'blob' });

      if (fileName) {
        saveAs(blob, `${fileName}.zip`);
      } else {
        saveAs(blob, 'DocumentosFiscais.zip');
      }
    }

    dispatch(setDownloadDocumentoFiscalSuccess());

    if (cb && typeof cb === 'function') cb();

    if (documentsReport.failed && documentsReport.failed.length > 0) {
      sendWarningModalXMLImport(documentsReport.failed, documentsReport.success);
    } else {
      sendSuccessModalXMLImport(documentsReport.success);
    }
  } catch (error) {
    sendErroRequest(error, 'Não foi possível baixar os Documentos Fiscais');

    dispatch(setDownloadDocumentoFiscalFail());
  }
};

export const deletarDocumentoFiscal = selectedRows => async (dispatch, getState) => {
  try {
    const {
      documentoFiscal: { documentosFiscais },
    } = getState();

    const { value } = await Swal.fire({
      title: 'Você tem certeza?',
      text: 'Você tem certeza que deseja deletar os documentos selecionados?',
      type: 'warning',
      focusCancel: true,
      showCancelButton: true,
      confirmButtonColor: '#18a689',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, pode deletar!',
    });

    if (!value) return;

    const documentosAtualizados = [...documentosFiscais];

    const deleteList = map(selectedRows, documentoFiscal => documentoFiscal.id);

    const response = await box.delete(`${urlBaseDocumentos}/range`, { data: deleteList });

    if (response.status === 200) {
      map(selectedRows, documentoFiscal => {
        remove(documentosAtualizados, documento => documento.id === documentoFiscal.id);
      });
    }

    createSuccessNotification('Documentos deletados com sucesso.');

    dispatch(setDocumentosFiscaisSuccess(documentosAtualizados));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível deletar o documento.');

    dispatch(setDeleteFail());
  }
};

export const buscarManualmenteNFe = (dadosBusca, cb) => async dispatch => {
  try {
    await box.post(`${urlBaseDocumentos}/realizar-busca/1`, dadosBusca);

    dispatch(setBuscarDocumentosSuccess());

    if (cb && typeof cb === 'function')
      cb(`Já começamos a buscar por novas NFe's. Quando a busca finalizar a gente te avisa.`);
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar novos documentos');

    dispatch(setBuscarDocumentosFail());
  }
};

export const buscarManualmenteCTe = (dadosBusca, cb) => async dispatch => {
  try {
    await box.post(`${urlBaseDocumentos}/realizar-busca/2`, dadosBusca);

    dispatch(setBuscarDocumentosSuccess());

    if (cb && typeof cb === 'function')
      cb(`Já começamos a buscar por novos CTe's. Quando a busca finalizar a gente te avisa.`);
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar novos documentos');

    dispatch(setBuscarDocumentosFail());
  }
};

export const processar = (selectedRows, cb) => async (dispatch, getState) => {
  try {
    const { value } = await Swal.fire({
      title: 'Você tem certeza?',
      text:
        'Os documentos processados terá o processamento desfeito. Os documentos não processados serão processados. Você tem certeza que deseja continuar?',
      type: 'warning',
      focusCancel: true,
      showCancelButton: true,
      confirmButtonColor: '#18a689',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, pode processar!',
    });

    if (!value) return;

    const {
      usuario: {
        pessoaLogada: { nome, email },
      },
      documentoFiscal: { documentosFiscais },
    } = getState();

    const documentosAtualizados = [...documentosFiscais];

    const usuario = `Processamento Manual [${nome} - ${email}]`;

    const promises = map(selectedRows, async documentoFiscal => {
      const { id, processado } = documentoFiscal;

      const dadosImportacao = {
        dataImportacao: moment().format('YYYYMMDDHHmm'),
        usuario,
        desfazer: processado,
      };

      await box.patch(`${urlBaseDocumentos}/confirmar-importacao/${id}`, dadosImportacao);

      const [removido] = remove(documentosAtualizados, documento => documento.id === id);

      const documentoAtualizado = {
        ...removido,
        processado: !processado,
        dadosImportacao: processado ? null : dadosImportacao,
      };

      documentosAtualizados.push(documentoAtualizado);
    });

    await Promise.all(promises);

    createSuccessNotification('Documentos processados com sucesso.');

    dispatch(setDocumentosFiscaisSuccess(documentosAtualizados));

    if (cb && typeof cb === 'function') cb();
  } catch (error) {
    dispatch({ type: 'PROCESS_FAIL' });
  }
};

export const alterarCancelado = (selectedRows, cb) => async (dispatch, getState) => {
  try {
    const { value } = await Swal.fire({
      title: 'Alterar status de Cancelado',
      text: 'Esta operação irá alternar o status de Cancelado dos documentos selecionados. Você tem certeza?',
      type: 'warning',
      focusCancel: true,
      showCancelButton: true,
      confirmButtonColor: '#e67e22',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Confirmar',
    });

    if (!value) return;

    const {
      documentoFiscal: { documentosFiscais },
    } = getState();

    const documentosAtualizados = [...documentosFiscais];

    const promises = map(selectedRows, async documentoFiscal => {
      const { id, cancelado } = documentoFiscal;

      await box.patch(`${urlBaseDocumentos}/alternar-cancelado/${id}`);

      const [removido] = remove(documentosAtualizados, documento => documento.id === id);

      const documentoAtualizado = {
        ...removido,
        cancelado: !cancelado,
        reprocessarPendente: true,
        processado: false,
      };

      documentosAtualizados.push(documentoAtualizado);
    });

    await Promise.all(promises);

    createSuccessNotification('Status de cancelado alterado com sucesso.');

    dispatch(setDocumentosFiscaisSuccess(documentosAtualizados));

    if (cb && typeof cb === 'function') cb();
  } catch (error) {
    sendErroRequest(error, 'Não foi possível alterar o status de cancelado.');
  }
};
